import { Box, type Palette } from '@mui/material';
import type { SerializedTextNode } from '@payloadcms/richtext-lexical/lexical';
import { formatToStyle } from './formatToStyle';
import { stateToStyle } from './stateToStyle';
import { stateToCustomSx } from './stateToCustomSx';
import { paletteToTokens } from './paletteToTokens';

interface TextNodeProps {
  node: SerializedTextNode;
  palette: Palette;
}

const TextNode = ({ node, palette }: TextNodeProps) => (
  <Box
    component="span"
    sx={[
      {
        color: 'inherit',
        ...formatToStyle(node.format),
        ...stateToStyle({ state: node.$, tokens: paletteToTokens(palette) }),
      },
      stateToCustomSx(node.$) ?? false,
    ]}
  >
    {node.text}
  </Box>
);

export default TextNode;
